// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9b73c4a7","952":"b41f6f86"}[chunkId] + ".chunk.js";
};